var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataFieldManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.27344,
    y: 4.76709,
    width: 7.67121,
    height: 10.0822,
    fill: "#888888"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2608 4.13287C16.1449 5.08935 16.8264 5.95867 17.7829 6.07455C18.7394 6.19043 19.6087 5.50898 19.7246 4.5525C19.8404 3.59601 19.159 2.72669 18.2025 2.61082C17.246 2.49494 16.3767 3.17639 16.2608 4.13287ZM15.0232 7.08606L18.1945 4.60012L17.7909 4.08525L14.6196 6.57119L15.0232 7.08606Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7419 8.60163C16.0755 9.29746 16.0993 10.4018 16.7952 11.0682C17.491 11.7346 18.5953 11.7108 19.2617 11.0149C19.9281 10.3191 19.9043 9.21477 19.2085 8.54836C18.5126 7.88195 17.4083 7.9058 16.7419 8.60163ZM14.8325 10.2205L18.0106 10.1353L17.993 9.48129L14.815 9.56649L14.8325 10.2205Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8906 13.6526C16.9271 13.6526 16.1461 14.4337 16.1461 15.3972C16.1461 16.3606 16.9271 17.1417 17.8906 17.1417C18.8541 17.1417 19.6352 16.3606 19.6352 15.3972C19.6352 14.4337 18.8541 13.6526 17.8906 13.6526ZM14.81 12.7791L17.6593 15.6285L18.1219 15.1659L15.2726 12.3166L14.81 12.7791Z",
    fill: "#888888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73918 4.13287C3.85506 5.08935 3.17361 5.95867 2.21713 6.07455C1.26064 6.19043 0.391323 5.50898 0.275446 4.5525C0.159569 3.59601 0.841016 2.72669 1.7975 2.61082C2.75398 2.49494 3.6233 3.17639 3.73918 4.13287ZM4.97682 7.08606L1.80552 4.60012L2.20911 4.08525L5.38042 6.57119L4.97682 7.08606Z",
    fill: "#888888"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26006 8.60163C3.92648 9.29746 3.90263 10.4018 3.20679 11.0682C2.51096 11.7346 1.40664 11.7108 0.740229 11.0149C0.0738171 10.3191 0.0976671 9.21477 0.7935 8.54836C1.48933 7.88195 2.59365 7.9058 3.26006 8.60163ZM5.16947 10.2205L1.99138 10.1353L2.00891 9.48129L5.187 9.56649L5.16947 10.2205Z",
    fill: "#888888"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10938 13.6526C3.07285 13.6526 3.85391 14.4337 3.85391 15.3972C3.85391 16.3606 3.07285 17.1417 2.10938 17.1417C1.1459 17.1417 0.364846 16.3606 0.364846 15.3972C0.364845 14.4337 1.1459 13.6526 2.10938 13.6526ZM5.18998 12.7791L2.34067 15.6285L1.87808 15.1659L4.72739 12.3166L5.18998 12.7791Z",
    fill: "#888888"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02734 6.63013H12.2465",
    stroke: "white",
    strokeWidth: 0.654199
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02734 8.71216H12.2465",
    stroke: "white",
    strokeWidth: 0.654199
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02734 10.7944H12.2465",
    stroke: "white",
    strokeWidth: 0.654199
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02734 12.8767H12.2465",
    stroke: "white",
    strokeWidth: 0.654199
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataFieldManagement);
export default __webpack_public_path__ + "static/media/dataFieldManagement.5e98ea81d0f875192be04a0b26934053.svg";
export { ForwardRef as ReactComponent };